import { createSupabaseAdminClient } from "@/lib/supabase/admin"

export type SavedRecipeRecord = {
  id: string
  userId: string
  recipeId: string
  createdAt: string
}

export async function getSavedRecipeIdsByUserId(userId: string): Promise<string[]> {
  const supabase = createSupabaseAdminClient()

  const { data, error } = await supabase
    .from("saved_recipes")
    .select("recipe_id")
    .eq("user_id", userId)
    .order("created_at", { ascending: false })

  if (error || !data) {
    console.error("Failed to load saved recipe ids:", error?.message)
    return []
  }

  return data.map((row) => row.recipe_id)
}

export async function isRecipeSavedByUser(
  userId: string,
  recipeId: string
): Promise<boolean> {
  const supabase = createSupabaseAdminClient()

  const { data, error } = await supabase
    .from("saved_recipes")
    .select("id")
    .eq("user_id", userId)
    .eq("recipe_id", recipeId)
    .maybeSingle()

  if (error) {
    console.error("Failed to check saved recipe:", error.message)
    return false
  }

  return Boolean(data)
}